var _g, _g2, _g3, _g4, _g5, _g6, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGameBoard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2348,
    height: 2135,
    viewBox: "0 0 2348 2135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15_285)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2288.21 1067.62L1828.96 1863.07L1742.6 1813.65L1717 1799L1717 1590L1898 1485.5L1898 1276.5L2079 1172L2079 962.998L2190.42 898.003L2288.21 1067.62Z",
    fill: "#7170CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1899.25 1487.67L1900.5 1486.94L1900.5 1485.5L1900.5 1277.94L2080.25 1174.16L2081.5 1173.44L2081.5 1172L2081.5 964.434L2189.51 901.429L2285.33 1067.62L1828.04 1859.66L1743.84 1811.48L1719.5 1797.55L1719.5 1591.44L1899.25 1487.67Z",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1970.08 1287.21L2105.1 1209.26C2119.32 1201.05 2128.09 1185.88 2128.1 1169.46L2128.28 963.36C2128.3 945.757 2118.27 929.689 2102.45 921.973L2076.76 909.448C2055.05 898.859 2028.84 906.872 2016.76 927.794L1532.19 1767.1C1515.33 1796.3 1534.56 1833.11 1568.16 1835.94L1714.19 1848.26C1740.83 1850.51 1763.77 1829.65 1764.05 1802.91L1765.8 1640.22C1765.97 1623.96 1774.71 1609.01 1788.79 1600.88L1924.08 1522.77C1938.31 1514.55 1947.08 1499.37 1947.08 1482.93L1947.08 1327.05C1947.08 1310.61 1955.84 1295.43 1970.08 1287.21Z",
    fill: "#F3BBF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1968.83 1285.05L2103.85 1207.09C2117.3 1199.33 2125.59 1184.98 2125.6 1169.46L2125.78 963.358C2125.8 946.712 2116.31 931.517 2101.35 924.22L2075.67 911.695C2055.13 901.682 2030.35 909.259 2018.93 929.044L1534.35 1768.35C1518.41 1795.96 1536.6 1830.77 1568.37 1833.45L1714.4 1845.77C1739.59 1847.89 1761.28 1828.17 1761.55 1802.89L1763.3 1640.19C1763.48 1623.05 1772.7 1607.28 1787.54 1598.71L1922.83 1520.61C1936.29 1512.83 1944.58 1498.47 1944.58 1482.93L1944.58 1327.05C1944.58 1309.72 1953.82 1293.71 1968.83 1285.05Z",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_15_285)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M617 102.5L1535.5 102.5L1535.89 202L1536 231.5L1355 336L1174 231.5L993 336L812 231.5L631 336L519 272L617 102.5Z",
    fill: "#7170CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1175.25 229.335L1174 228.613L1172.75 229.335L993 333.113L813.25 229.335L812 228.613L810.75 229.335L630.994 333.117L522.422 271.076L618.442 105L1533.01 105L1533.39 202.01L1533.49 230.06L1355 333.113L1175.25 229.335Z",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M966.237 268.221L831.214 190.265C816.994 182.055 799.476 182.048 785.249 190.245L606.67 293.135C591.417 301.923 582.517 318.645 583.747 336.205L585.742 364.712C587.429 388.812 607.471 407.5 631.63 407.5L1600.78 407.5C1634.49 407.5 1656.75 372.437 1642.41 341.929L1580.06 209.304C1568.69 185.11 1539.16 175.675 1515.86 188.793L1374.09 268.629C1359.93 276.607 1342.6 276.514 1328.52 268.385L1193.24 190.279C1179 182.062 1161.47 182.062 1147.24 190.279L1012.24 268.221C998.005 276.438 980.47 276.438 966.237 268.221Z",
    fill: "#F3BBF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M964.987 270.386L829.964 192.43C816.517 184.667 799.951 184.659 786.497 192.411L607.918 295.301C593.494 303.611 585.078 319.424 586.241 336.03L588.236 364.538C589.831 387.327 608.784 405 631.63 405L1600.78 405C1632.66 405 1653.71 371.843 1640.15 342.993L1577.8 210.367C1567.04 187.488 1539.12 178.566 1517.09 190.971L1375.32 270.807C1360.38 279.219 1342.12 279.121 1327.27 270.55L1191.99 192.444C1178.53 184.673 1161.95 184.673 1148.49 192.444L1013.49 270.386C998.481 279.05 979.993 279.05 964.987 270.386Z",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 5
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_15_285)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.7855 1067.38L519.036 271.932L605.398 321.348L631.003 335.999L631.002 544.999L450.003 649.5L450.002 858.501L269.003 963.001L269.002 1172L157.577 1237L59.7855 1067.38Z",
    fill: "#7170CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.753 647.335L447.503 648.057L447.503 649.5L447.502 857.057L267.753 960.836L266.503 961.558L266.503 963.001L266.502 1170.57L158.488 1233.57L62.6717 1067.38L519.955 275.338L604.156 323.518L628.503 337.449L628.502 543.556L448.753 647.335Z",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.923 847.788L242.899 925.744C228.68 933.954 219.914 949.121 219.899 965.54L219.715 1171.64C219.699 1189.24 229.731 1205.31 245.553 1213.03L271.239 1225.55C292.953 1236.14 319.159 1228.13 331.238 1207.21L815.815 367.895C832.67 338.701 813.435 301.891 779.844 299.058L633.812 286.741C607.172 284.494 584.235 305.352 583.948 332.085L582.204 494.779C582.03 511.036 573.287 525.994 559.207 534.123L423.923 612.229C409.691 620.447 400.923 635.632 400.923 652.066L400.923 807.951C400.923 824.385 392.155 839.571 377.923 847.788Z",
    fill: "#F3BBF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.173 849.953L244.149 927.909C230.702 935.673 222.413 950.015 222.399 965.543L222.215 1171.64C222.2 1188.29 231.687 1203.48 246.649 1210.78L272.335 1223.31C292.869 1233.32 317.65 1225.74 329.073 1205.96L813.65 366.645C829.589 339.038 811.399 304.229 779.633 301.549L633.602 289.232C608.41 287.107 586.719 306.832 586.448 332.112L584.704 494.806C584.52 511.947 575.302 527.717 560.457 536.288L425.173 614.394C411.714 622.165 403.423 636.525 403.423 652.066L403.423 807.951C403.423 825.278 394.179 841.29 379.173 849.953Z",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 5
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_15_285)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1731 2032.5L812.5 2032.5L812.114 1933L812 1903.5L993 1799L1174 1903.5L1355 1799L1536 1903.5L1717 1799L1829 1863L1731 2032.5Z",
    fill: "#7170CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1172.75 1905.67L1174 1906.39L1175.25 1905.67L1355 1801.89L1534.75 1905.67L1536 1906.39L1537.25 1905.67L1717.01 1801.88L1825.58 1863.92L1729.56 2030L814.99 2030L814.614 1932.99L814.506 1904.94L993 1801.89L1172.75 1905.67Z",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1381.76 1866.78L1516.79 1944.73C1531.01 1952.94 1548.52 1952.95 1562.75 1944.76L1741.33 1841.87C1756.58 1833.08 1765.48 1816.36 1764.25 1798.8L1762.26 1770.29C1760.57 1746.19 1740.53 1727.5 1716.37 1727.5L747.217 1727.5C713.507 1727.5 691.246 1762.56 705.588 1793.07L767.937 1925.7C779.311 1949.89 808.844 1959.33 832.138 1946.21L973.907 1866.37C988.074 1858.39 1005.4 1858.49 1019.48 1866.62L1154.76 1944.72C1169 1952.94 1186.53 1952.94 1200.76 1944.72L1335.76 1866.78C1350 1858.56 1367.53 1858.56 1381.76 1866.78Z",
    fill: "#F3BBF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1383.01 1864.61L1518.04 1942.57C1531.48 1950.33 1548.05 1950.34 1561.5 1942.59L1740.08 1839.7C1754.51 1831.39 1762.92 1815.58 1761.76 1798.97L1759.76 1770.46C1758.17 1747.67 1739.22 1730 1716.37 1730L747.217 1730C715.339 1730 694.288 1763.16 707.851 1792.01L770.2 1924.63C780.956 1947.51 808.883 1956.43 830.911 1944.03L972.681 1864.19C987.617 1855.78 1005.88 1855.88 1020.73 1864.45L1156.01 1942.56C1169.47 1950.33 1186.05 1950.33 1199.51 1942.56L1334.51 1864.61C1349.52 1855.95 1368.01 1855.95 1383.01 1864.61Z",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 5
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_15_285)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1731.21 102.624L2190.46 898.068L2104.49 948.152L2079 963.001L1898 858.5L1898 649.5L1717 544.999L1717 335.999L1536 231.498L1535.42 102.503L1731.21 102.624Z",
    fill: "#7170CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1900.5 649.5L1900.5 648.056L1899.25 647.335L1719.5 543.556L1719.5 335.999L1719.5 334.555L1718.25 333.834L1538.49 230.051L1537.93 105.005L1729.77 105.123L2187.05 897.161L2103.23 945.992L2078.99 960.111L1900.5 857.057L1900.5 649.5Z",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1762.31 487.933L1762.31 332.021C1762.31 315.601 1753.56 300.427 1739.35 292.204L1560.95 188.995C1545.72 180.18 1526.79 180.833 1512.19 190.678L1488.5 206.66C1468.48 220.17 1462.31 246.872 1474.39 267.794L1958.97 1107.1C1975.82 1136.3 2017.32 1138.05 2036.57 1110.37L2120.25 990.062C2135.52 968.115 2128.92 937.822 2105.91 924.207L1965.89 841.35C1951.9 833.07 1943.31 818.02 1943.31 801.762L1943.31 645.549C1943.31 629.115 1934.55 613.929 1920.31 605.712L1785.31 527.77C1771.08 519.553 1762.31 504.367 1762.31 487.933Z",
    fill: "#F3BBF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1759.81 487.933L1759.81 332.021C1759.81 316.494 1751.54 302.144 1738.1 294.368L1559.7 191.159C1545.29 182.823 1527.39 183.441 1513.59 192.75L1489.9 208.732C1470.96 221.509 1465.13 246.759 1476.56 266.544L1961.13 1105.85C1977.07 1133.46 2016.31 1135.11 2034.52 1108.94L2118.2 988.635C2132.63 967.88 2126.4 939.234 2104.64 926.359L1964.62 843.501C1949.86 834.772 1940.81 818.903 1940.81 801.762L1940.81 645.549C1940.81 630.008 1932.52 615.648 1919.06 607.877L1784.06 529.935C1769.06 521.271 1759.81 505.26 1759.81 487.933Z",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 5
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_15_285)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M616.785 2032.38L157.535 1236.93L243.512 1186.85L269.003 1172L450.002 1276.5L450.003 1485.5L631.002 1590L631.003 1799L812.002 1903.5L812.577 2032.5L616.785 2032.38Z",
    fill: "#7170CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.503 1485.5L447.503 1486.94L448.753 1487.67L628.502 1591.44L628.503 1799L628.503 1800.44L629.753 1801.17L809.509 1904.95L810.066 2030L618.229 2029.88L160.946 1237.84L244.771 1189.01L269.008 1174.89L447.502 1277.94L447.503 1485.5Z",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.686 1647.07L585.686 1802.98C585.686 1819.4 594.438 1834.57 608.65 1842.8L787.045 1946C802.282 1954.82 821.214 1954.17 835.806 1944.32L859.497 1928.34C879.524 1914.83 885.688 1888.13 873.608 1867.21L389.032 1027.9C372.177 998.701 330.681 996.954 311.432 1024.63L227.749 1144.94C212.483 1166.88 219.078 1197.18 242.086 1210.79L382.111 1293.65C396.103 1301.93 404.686 1316.98 404.686 1333.24L404.686 1489.45C404.686 1505.88 413.453 1521.07 427.686 1529.29L562.686 1607.23C576.918 1615.45 585.686 1630.63 585.686 1647.07Z",
    fill: "#F3BBF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.186 1647.07L588.186 1802.98C588.186 1818.51 596.462 1832.86 609.902 1840.63L788.297 1943.84C802.706 1952.18 820.609 1951.56 834.408 1942.25L858.099 1926.27C877.038 1913.49 882.866 1888.24 871.443 1868.46L386.867 1029.15C370.928 1001.54 331.687 999.886 313.484 1026.06L229.801 1146.36C215.365 1167.12 221.602 1195.77 243.36 1208.64L383.384 1291.5C398.137 1300.23 407.186 1316.1 407.186 1333.24L407.186 1489.45C407.186 1504.99 415.477 1519.35 428.936 1527.12L563.936 1605.06C578.941 1613.73 588.186 1629.74 588.186 1647.07Z",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M999.999 552.5L1181 657V866L999.999 970.5L819 866V657L999.999 552.5Z",
    fill: "#7879F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M821.5 658.443L999.999 555.387L1178.5 658.443V864.557L999.999 967.613L821.5 864.557V658.443Z",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1542 866.5L1723 971V1180L1542 1284.5L1361 1180V971L1542 866.5Z",
    fill: "#7879F1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1363.5 972.443L1542 869.387L1720.5 972.443V1178.56L1542 1281.61L1363.5 1178.56V972.443Z",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1358 1182.5L1539 1287V1496L1358 1600.5L1177 1496V1287L1358 1182.5Z",
    fill: "#5D5FEF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1179.5 1288.44L1358 1185.39L1536.5 1288.44V1494.56L1358 1597.61L1179.5 1494.56V1288.44Z",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1542 1498.5L1723 1603V1812L1542 1916.5L1361 1812V1603L1542 1498.5Z",
    fill: "#7879F1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1363.5 1604.44L1542 1501.39L1720.5 1604.44V1810.56L1542 1913.61L1363.5 1810.56V1604.44Z",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1543 235.5L1724 340V549L1543 653.5L1362 549V340L1543 235.5Z",
    fill: "#7879F1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1364.5 341.443L1543 238.387L1721.5 341.443V547.557L1543 650.613L1364.5 547.557V341.443Z",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1725 1182.5L1906 1287V1496L1725 1600.5L1544 1496V1287L1725 1182.5Z",
    fill: "#F178B6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1546.5 1288.44L1725 1185.39L1903.5 1288.44V1494.56L1725 1597.61L1546.5 1494.56V1288.44Z",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 5
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M449.999 862.5L630.999 967V1176L449.999 1280.5L269 1176V967L449.999 862.5Z",
    fill: "#F178B6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M271.5 968.443L449.999 865.387L628.499 968.443V1174.56L449.999 1277.61L271.5 1174.56V968.443Z",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 5
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M811.999 1497.5L992.999 1602V1811L811.999 1915.5L631 1811V1602L811.999 1497.5Z",
    fill: "#F178B6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M633.5 1603.44L811.999 1500.39L990.499 1603.44V1809.56L811.999 1912.61L633.5 1809.56V1603.44Z",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 5
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1905 864.5L2086 969V1178L1905 1282.5L1724 1178V969L1905 864.5Z",
    fill: "#5D5FEF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1726.5 970.443L1905 867.387L2083.5 970.443V1176.56L1905 1279.61L1726.5 1176.56V970.443Z",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 5
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M817.999 236.5L998.999 341V550L817.999 654.5L637 550V341L817.999 236.5Z",
    fill: "#5D5FEF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M639.5 342.443L817.999 239.387L996.499 342.443V548.557L817.999 651.613L639.5 548.557V342.443Z",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 5
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1723 550.5L1904 655V864L1723 968.5L1542 864V655L1723 550.5Z",
    fill: "#F178B6"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M1544.5 656.443L1723 553.387L1901.5 656.443V862.557L1723 965.613L1544.5 862.557V656.443Z",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 5
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M633.999 549.5L814.999 654V863L633.999 967.5L453 863V654L633.999 549.5Z",
    fill: "#7879F1"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M455.5 655.443L633.999 552.387L812.499 655.443V861.557L633.999 964.613L455.5 861.557V655.443Z",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 5
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M1180 236.5L1361 341V550L1180 654.5L999 550V341L1180 236.5Z",
    fill: "#F178B6"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M1001.5 342.443L1180 239.387L1358.5 342.443V548.557L1180 651.613L1001.5 548.557V342.443Z",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 5
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M1175 1500.5L1356 1605V1814L1175 1918.5L994 1814V1605L1175 1500.5Z",
    fill: "#5D5FEF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M996.5 1606.44L1175 1503.39L1353.5 1606.44V1812.56L1175 1915.61L996.5 1812.56V1606.44Z",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 5
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M629.999 1182.5L810.999 1287V1496L629.999 1600.5L449 1496V1287L629.999 1182.5Z",
    fill: "#5D5FEF"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M451.5 1288.44L629.999 1185.39L808.499 1288.44V1494.56L629.999 1597.61L451.5 1494.56V1288.44Z",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 5
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M814.999 865.5L995.999 970V1179L814.999 1283.5L634 1179V970L814.999 865.5Z",
    fill: "#5D5FEF"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M636.5 971.443L814.999 868.387L993.499 971.443V1177.56L814.999 1280.61L636.5 1177.56V971.443Z",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 5
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M1181 867.5L1362 972V1181L1181 1285.5L1000 1181V972L1181 867.5Z",
    fill: "#F178B6"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M1002.5 973.443L1181 870.387L1359.5 973.443V1179.56L1181 1282.61L1002.5 1179.56V973.443Z",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 5
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M1362 550.5L1543 655V864L1362 968.5L1181 864V655L1362 550.5Z",
    fill: "#5D5FEF"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M1183.5 656.443L1362 553.387L1540.5 656.443V862.557L1362 965.613L1183.5 862.557V656.443Z",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 5
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M993.999 1183.5L1175 1288V1497L993.999 1601.5L813 1497V1288L993.999 1183.5Z",
    fill: "#7879F1"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M815.5 1289.44L993.999 1186.39L1172.5 1289.44V1495.56L993.999 1598.61L815.5 1495.56V1289.44Z",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15_285"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1037,
    height: 234,
    fill: "white",
    transform: "translate(1626.06 1746.5) rotate(-60)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_15_285"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1037,
    height: 234,
    fill: "white",
    transform: "translate(1536 336.5) rotate(180)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_15_285"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1037,
    height: 234,
    fill: "white",
    transform: "translate(721.936 388.499) rotate(120)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_15_285"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1037,
    height: 234,
    fill: "white",
    transform: "translate(812 1798.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_15_285"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1037,
    height: 234,
    fill: "white",
    transform: "translate(1988.06 1015.5) rotate(-120)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_15_285"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1037,
    height: 234,
    fill: "white",
    transform: "translate(359.936 1119.5) rotate(60)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGameBoard);
export default __webpack_public_path__ + "static/media/GameBoard.4f33cf563004c158b67e1022a5a05e79.svg";
export { ForwardRef as ReactComponent };